import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { dashboardSelector } from "@/store/features/dashboardSlice";
import { useGlobalModal } from "@/hooks/useGlobalModal";

export const useNavigationGuard = () => {
  const { action } = useSelector(dashboardSelector);
  const navigate = useNavigate();
  const { showModal, hideModal } = useGlobalModal();

  const handleNavigation = (path: string) => {
    // console.log({ action, path });
    if (action) {
      return new Promise((resolve, reject) => {
        showModal("confirmationModal", {
          message: "Please save the information before leaving this page.",
          confirmText: "Leave",
          cancelText: "Stay",
          title: "Attention",
          handleConfirm: () => {
            hideModal();
            navigate(path);
            resolve(true);
          },
          handleCancel: () => {
            hideModal();
            reject(new Error("Navigation cancelled"));
          },
        });
      });
    } else {
      navigate(path);
      return Promise.resolve(true);
    }
  };

  return handleNavigation;
};

export const handleCustomNavigation = (link: string, navigate: (path: string) => void, callBack?: any): void => {
  if (!link) return;
  if (link.includes("http://") || link.includes("https://")) {
    // Open external link in new window
    window.open(link, "_blank", "noopener,noreferrer");
  } else {
    // Navigate to internal route
    navigate(link);
  }
  if (callBack) callBack();
};
